import React from 'react'
import styles from './contact.module.css';
import {  BsLinkedin } from "react-icons/bs";
import { FaGithubSquare } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa";
import { AiFillMediumSquare } from "react-icons/ai";
import { MdCall } from "react-icons/md";
import { Box, Flex, IconButton } from '@chakra-ui/react';
const Contact = () => {
  return (
    <div id='contact_section' className={styles.contact}> 
          <Box>
            <h1 className={styles.heading}>Let's connect: </h1>
            <Flex>
              <IconButton className={styles.iconBtn} ml={5} mt={3} mr={5} icon={<FaEnvelope />} 
                
              > </IconButton>
              <p className={styles.anchor} >pandeyratnesh1997@gmail.com</p>
            </Flex>
            <Flex >
              <IconButton ml={5} mt={3}  mr={5} icon={<BsLinkedin />}
              onClick={()=>
                window.open("https://www.linkedin.com/in/ratnesh-pandey-068771232/")
                } 
                
              > </IconButton>
              <a className={styles.anchor} href="https://www.linkedin.com/in/ratnesh-pandey-068771232/" target="_blank" >https://www.linkedin.com/in/ratnesh-pandey-068771232/</a>
            </Flex>
            <Flex>
              <IconButton ml={5} mt={3} mr={5} icon={<FaGithubSquare/>} 
                onClick={()=>
                  window.open("https://github.com/pandeyratnesh1997")
                }
              > </IconButton>
              <p className={styles.anchor} >https://github.com/pandeyratnesh1997</p>
            </Flex>
            <Flex>
              <IconButton ml={5} mt={3} mr={5} icon={<AiFillMediumSquare/>} 
                onClick={()=>
                  window.open("https://medium.com/@pandeyratnesh1997")
                }
              > </IconButton>
              <p className={styles.anchor} >https://medium.com/@pandeyratnesh1997</p>
            </Flex>
            <Flex>
              <IconButton ml={5} mt={3} mr={5} icon={<MdCall />} 
                
              > </IconButton>
              <p className={styles.anchor} >7278053703</p>
            </Flex>
        
          </Box>
    </div>
  )
}

export default Contact